import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Typography,
    Box
} from '@mui/material';
import {
    CheckCircle as CheckIcon,
    Cancel as CancelIcon
} from '@mui/icons-material';


function getSkillColumnCell(skillList) {
    return skillList.map((skill, index) => (
        <TableCell
            key={index}
            sx={{
                fontWeight: 600,
                fontSize: '0.95rem',
                color: 'text.secondary',
                borderBottom: '2px solid',
                borderColor: 'divider',
                maxWidth: 100,
                py: 2
            }}
        >
            <Box>
                <Typography variant="body2" fontWeight={500}>
                    {skill.display_name}
                </Typography>
            </Box>
        </TableCell>
    ));
}

const getMemberSkillValueCells = (row, skillList) => {
    let skillDataList = row.skill_data || [];

    let skillDataMap = {};
    skillDataList.forEach((skillData) => {
        console.debug("skillData=", skillData);
        skillDataMap[skillData.skill_code] = 
         `${skillData.rank_score} (成績: ${skillData.skill_score} ${skillData.unit})`;
        //  skillData.rank_score;
    });


    return skillList.map((skill, index) => {
        const skillValue = skillDataMap[skill.skill_code] !== undefined ?
            skillDataMap[skill.skill_code] : '-';
            

        return (
            <TableCell key={index}>
                <Typography
                    variant="body2"
                    fontWeight={500}
                    color={skillValue !== '-' ? 'text.primary' : 'text.secondary'}
                >
                    {skillValue}
                </Typography>
            </TableCell>
        );
    });
}

const EventSkillOverviewTable = ({ memberResultData, skillList }) => {
    // 預設資料
    const defaultData = [
        {
            display_name: '陳小美',
            group: '1A',
            group_num: '01',
            is_completed: true,
            total_rank_score: 12
        },
        {
            display_name: '陳小美',
            group: '1A',
            group_num: '02',
            is_completed: false,
            total_rank_score: 0
        }
    ];

    const mySkillData = skillList || [];
    const tableData = memberResultData || defaultData;

    // 表頭配置
    const columns = [
        { id: 'name', label: '名字', minWidth: 100 },
        { id: 'class', label: '班別', minWidth: 80 },
        { id: 'number', label: '班號', minWidth: 80 },
        { id: 'isCompleted', label: '是否完成', minWidth: 100 },
        { id: 'score', label: '總成績', minWidth: 100 }
    ];

    return (
        <TableContainer
            component={Paper}
            sx={{
                boxShadow: 2,
                borderRadius: 2,
                overflow: 'hidden'
            }}
        >
            <Table sx={{ minWidth: 500 }}>
                <TableHead>
                    <TableRow sx={{ bgcolor: 'grey.50' }}>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '0.95rem',
                                    color: 'text.secondary',
                                    borderBottom: '2px solid',
                                    borderColor: 'divider',
                                    minWidth: column.minWidth,
                                    py: 2
                                }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                        {getSkillColumnCell(mySkillData)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((row, index) => (
                        <TableRow
                            key={index}
                            hover
                            sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                                '&:hover': {
                                    bgcolor: 'grey.50'
                                }
                            }}
                        >
                            <TableCell sx={{ py: 2 }}>
                                <Typography variant="body2" fontWeight={500}>
                                    {row.display_name}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2">
                                    {row.group}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2">
                                    {row.group_num}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                {row.is_completed ? (
                                    <Chip
                                        icon={<CheckIcon sx={{ fontSize: 18 }} />}
                                        label="YES"
                                        size="small"
                                        sx={{
                                            bgcolor: 'success.light',
                                            color: 'success.dark',
                                            fontWeight: 500,
                                            '& .MuiChip-icon': {
                                                color: 'success.dark'
                                            }
                                        }}
                                    />
                                ) : (
                                    <Chip
                                        icon={<CancelIcon sx={{ fontSize: 18 }} />}
                                        label="NO"
                                        size="small"
                                        sx={{
                                            bgcolor: 'error.light',
                                            color: 'error.dark',
                                            fontWeight: 500,
                                            '& .MuiChip-icon': {
                                                color: 'error.dark'
                                            }
                                        }}
                                    />
                                )}
                            </TableCell>
                            <TableCell>
                                <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    color={row.total_rank_score > 0 ? 'text.primary' : 'text.secondary'}
                                >
                                    {row.total_rank_score}
                                </Typography>
                            </TableCell>

                            { /* Looping the skill */}
                            {getMemberSkillValueCells(row, mySkillData)}

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default EventSkillOverviewTable;